import { render, staticRenderFns } from "./add_group_model.vue?vue&type=template&id=20f3f8d4&scoped=true&"
import script from "./add_group_model.vue?vue&type=script&lang=js&"
export * from "./add_group_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3f8d4",
  null
  
)

export default component.exports